import {podcast_carousel} from "../blocks/podcastcarousel";
import {headingAnimation} from '../pages/new-h1-animation';
import Cookies from 'js-cookie';

export function bodyClassCheck() {

    if ($('body').hasClass('b2b-a-ceo')) {
        podcast_carousel();
    }

    if ($('body').hasClass('home') && !Cookies.get('visited')) {
        Cookies.set('visited', 'yes', {expires: 1});
        headingAnimation();
    } else {
        $('.hero').css({opacity: 1});
        $('.hero-link.heading_text_4').css({color: "#40C0C0"});
        $('.hero .wp-block-buttons').css({opacity: 1});
        $('.home .marquee-container').css({opacity: 1});

    }
}